import Vue from "vue";

import VueRouter from "vue-router";
Vue.use(VueRouter);

//import pages

const HomePage = () => import("../pages/Home.vue");
const SignUpPage = () => import("../pages/user/SignUp.vue");
const LogInPage = () => import("../pages/user/LogIn.vue");
const DirectoryPage = () => import("../pages/Directory.vue");
const CreateAssets = () => import("../pages/user/CreateAssets.vue");
const PasswordResetPage = () => import("../pages/user/PasswordReset.vue");
const PasswordResetConfirmPage = () =>
    import("../pages/user/PasswordResetConfirm.vue");
const paymentMethodPage = () => import("../pages/user/paymentMethod.vue");
const ordersPage = () => import("../pages/user/orders/index.vue");
const feedbackPage = () => import("../pages/user/feedback/index.vue");
const customerPage = () => import("../pages/user/customers/index.vue");
const settingsBusinessPage = () =>
    import("../pages/user/settings/Business.vue");
const settingsMenuPage = () => import("../pages/user/settings/Menu.vue");
const settingsMediaPage = () => import("../pages/user/settings/Media.vue");
const settingsSocialPage = () => import("../pages/user/settings/Social.vue");
const settingsQRCodesPage = () => import("../pages/user/settings/QRCodes.vue");
const settingsContactTracingPage = () =>
    import("../pages/user/settings/ContactTracing.vue");
const settingsFeedbackPage = () =>
    import("../pages/user/settings/Feedback.vue");
const settingsSubscriptionsPage = () =>
    import("../pages/user/settings/Subscriptions.vue");
const settingsOnlineOrderingPage = () =>
    import("../pages/user/settings/OnlineOrdering.vue");
const settingsLoyaltyPage = () => import("../pages/user/settings/Loyalty.vue");
const guestsPage = () => import("../pages/user/guests.vue");
const assetsPage = () => import("../pages/user/assets.vue");
const menuIndexPage = () => import("../pages/menu/index.vue");
const AdminNotificationPage = () => import("../pages/admin/notifications.vue");
const checkoutIndexPage = () => import("../components/cart/Checkout.vue");
const checkoutSuccessPage = () => import("../components/cart/Success.vue");
const notFound = () => import("../pages/NotFound.vue");

import store from "../store";

const routes = [
    {
        path: "/404",
        name: "404",
        component: notFound,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/checkout",
        name: "customerCheckout",
        component: checkoutIndexPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/checkout/success",
        name: "customerCheckoutSuccess",
        component: checkoutSuccessPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/cart",
        name: "customerCart",
        component: menuIndexPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu/items/add",
        name: "menuItemsAdd",
        component: menuIndexPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu/categories/add",
        name: "menuCategoriesAdd",
        component: menuIndexPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/contact",
        name: "menuContact",
        component: menuIndexPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/about",
        name: "menuAbout",
        component: menuIndexPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu/register",
        name: "menuRegister",
        component: menuIndexPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu/:categorySlug/:itemSlug",
        name: "menuItem",
        component: menuIndexPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu/categories/:categorySlug/edit",
        name: "menuCategoriesEdit",
        component: menuIndexPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu/:categorySlug/:itemSlug/edit",
        name: "menuItemEdit",
        component: menuIndexPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu/options",
        name: "menuItemOptions",
        component: menuIndexPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu/cross-sell-groups",
        name: "menuItemCrossSellGroups",
        component: menuIndexPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug",
        name: "userIndex",
        component: menuIndexPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/menu",
        name: "menuIndex",
        component: menuIndexPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },

    {
        path: "/:userSlug/subscription/payment-method",
        name: "paymentMethod",
        component: paymentMethodPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/qr-codes",
        name: "userAssets",
        component: assetsPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/qr-codes/download",
        name: "userAssetsDownload",
        component: assetsPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/orders/:status",
        name: "userOrders",
        component: ordersPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/feedback",
        name: "userFeedback",
        component: feedbackPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/customers",
        name: "userCustomers",
        component: customerPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/business",
        name: "userSettings",
        component: settingsBusinessPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/menu",
        name: "userSettingsMenu",
        component: settingsMenuPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/media",
        name: "userSettingsMedia",
        component: settingsMediaPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/social",
        name: "userSettingsSocial",
        component: settingsSocialPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/qr-codes",
        name: "userSettingsQRCodes",
        component: settingsQRCodesPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/contact-tracing",
        name: "userSettingsContactTracing",
        component: settingsContactTracingPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/feedback",
        name: "userSettingsFeedback",
        component: settingsFeedbackPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/subscriptions",
        name: "userSettingsSubscriptions",
        component: settingsSubscriptionsPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/online-ordering",
        name: "userSettingsOnlineOrdering",
        component: settingsOnlineOrderingPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/loyalty",
        name: "userSettingsLoyalty",
        component: settingsLoyaltyPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/settings/online-ordering/reauth",
        name: "userSettingsOnlineOrderingReauth",
        component: settingsOnlineOrderingPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/:userSlug/guests",
        name: "userGuests",
        component: guestsPage,
        meta: {
            allowAnonymous: false,
            allowUser: true,
        },
    },
    {
        path: "/user/password/reset",
        name: "passwordReset",
        component: PasswordResetPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/user/password/reset/:token",
        name: "passwordResetConfirm",
        component: PasswordResetConfirmPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        //leave allow anonymous as true, false slows down sign up for some reason, no time to investigate
        path: "/user/assets/create",
        name: "createAssets",
        component: CreateAssets,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/user/login",
        name: "logIn",
        component: LogInPage,
        meta: {
            allowAnonymous: true,
            allowUser: false,
        },
    },
    {
        path: "/user/signup",
        name: "signUp",
        component: SignUpPage,
        meta: {
            allowAnonymous: true,
            allowUser: false,
        },
    },
    {
        path: "/",
        name: "home",
        component: HomePage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/restaurants/:featured",
        name: "directoryFeatured",
        component: DirectoryPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/restaurants/:country/:state_slug/:neighborhood",
        name: "directory",
        component: DirectoryPage,
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
    {
        path: "/admin/notifications",
        name: "adminNotifications",
        component: AdminNotificationPage,
        meta: {
            allowAnonymous: false,
            allowUser: false,
            allowAdmin: true,
        },
    },
    {
        path: "*",
        redirect: "/404",
        meta: {
            allowAnonymous: true,
            allowUser: true,
        },
    },
];

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0,
            };
        }
    },
    mode: "history",
});

router.beforeEach((to, from, next) => {
    store.dispatch("setAppProcessing", true);
    if (!to.meta.allowAnonymous || !to.meta.allowUser) {
        store.dispatch("users/getUser").then((result) => {
            if (!to.meta.allowAnonymous && !store.state.users.user.id) {
                next({
                    name: "logIn",
                });
            } else if (!to.meta.allowUser && store.state.users.user.id) {
                if (to.meta.allowAdmin && store.state.users.user.id == 1) {
                    next();
                } else {
                    router.push({
                        name: "menuIndex",
                        params: {
                            userSlug: store.state.users.user.slug,
                        },
                    });
                }
            } else {
                next();
            }
        });
    } else {
        next();
    }
});

router.afterEach((to, from) => {
    store.dispatch("setAppProcessing", false);
});

export default router;
